<template>
  <v-app-bar app color="base_1">
    <v-row no-gutters align="center" class="toolbar-row">
      <v-col cols="3" class="d-flex align-center justify-start">
        <v-img :src="logoSrc" max-height="50" max-width="50" contain />
      </v-col>

      <v-col cols="6" class="d-flex align-center justify-center">
        <h2 class="primary--text toolbar-title">Familiestatuut</h2>
      </v-col>

      <v-col cols="3" class="d-flex align-center justify-end">
        <v-btn icon @click="toggle_dark_mode">
          <v-icon>mdi-theme-light-dark</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import AuthService from "@/services/AuthService";
export default {
  name: "ToolBarAuth",
  data() {
    return {
      theme: null,
    };
  },
  methods: {
    toggle_dark_mode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
    async logout() {
      await this.logoutExt();
      await localStorage.clear();
      await this.$router.push({ name: "login_family" });
    },

    logoutExt() {
      const payload = {
        email: this.email,
      };
      AuthService.logout(payload).then(() => {
        console.log("logged out extern");
      });
    },
  },
  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
      this.$vuetify.theme.dark = theme === "true";
    }
  },
  computed: {
    ...mapGetters("auth", ["email"]),
    logoSrc() {
      return this.$vuetify.theme.dark
        ? require("@/assets/bakerlogojust-lichter.png")
        : require("@/assets/bakerlogojust.png");
    },
  },
};
</script>

<style scoped></style>
